import React, { useState, useEffect } from 'react'
import './AnalyzeTokenUsage.css'

const endpoints = {
  'bot.dev.stratsys.net': 'https://data-ai-insights.svc.dev.stratsys.net',
  'bot.test.stratsys.net': 'https://data-ai-insights.svc.test.stratsys.net',
  'bot.stratsys.com': 'https://data-ai-insights.svc.stratsys.com',
  'localhost:8080': 'http://localhost:5001'
}
const AnalyzeTokenUsage = () => {
  const [data, setData] = useState([]) // raw tenants data
  const [searchTerm, setSearchTerm] = useState('')
  const [includeZero, setIncludeZero] = useState(false)

  // Fetch the data once the component mounts
  useEffect(() => {
    handleFetchData()
  }, [])

  const handleFetchData = async () => {
    try {
      // Make sure the "endpoints" object is available in your context.
      const response = await window.PDR.api.get(`${endpoints[window.location.host]}/get_token_usage`)
      // Assume the response contains a "tenants" array.
      setData(response.tenants)
    } catch (error) {
      console.error('Error fetching token usage data:', error)
    }
  }

  // Update search term state when the input changes.
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value)
  }

  // Update checkbox state.
  const handleCheckboxChange = (e) => {
    setIncludeZero(e.target.checked)
  }

  // First, filter the data based on the search term and checkbox.
  const filteredData = data.filter((tenant) => {
    // Filter by name (case-insensitive)
    if (searchTerm && !tenant.name.toLowerCase().includes(searchTerm.toLowerCase())) {
      return false
    }
    // If the checkbox is NOT checked, filter out tenants with 0 tokens remaining.
    if (!includeZero && tenant.tokensRemaining === 0) {
      return false
    }
    return true
  })

  // Then, sort the data by percentage of tokens remaining.
  // If tokensTotal is 0, we treat percentage as 0 to avoid dividing by zero.
  // Here, we sort in descending order so that tenants with the highest percentage left are at the top.
  const sortedData = filteredData.sort((b, a) => {
    const percentageA = a.tokensTotal > 0 ? (a.tokensRemaining / a.tokensTotal) * 100 : 0
    const percentageB = b.tokensTotal > 0 ? (b.tokensRemaining / b.tokensTotal) * 100 : 0
    return percentageB - percentageA
  })

  return (
    <div className="analyze-token-usage">
      <h1>Analyze Token Usage</h1>
      <div className="filter-bar">
        <input type="text" placeholder="Search by name..." value={searchTerm} onChange={handleSearchChange} />
        <label>
          <input type="checkbox" checked={includeZero} onChange={handleCheckboxChange} />
          Include tenants with 0 tokens remaining
        </label>
      </div>
      <table className="token-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>ID</th>
            <th>Has License</th>
            <th>Tokens Remaining</th>
            <th>Tokens Total</th>
            <th>Percentage Left</th>
            <th>Expected token expiration date</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((tenant) => {
            const percentage = tenant.tokensTotal > 0 ? (tenant.tokensRemaining / tenant.tokensTotal) * 100 : 0
            const expirationDate = tenant.tokenForecast ? tenant.tokenForecast.estimatedExpirationDate : ''
            return (
              <tr key={tenant.id}>
                <td>{tenant.name}</td>
                <td>{tenant.id}</td>
                <td>{tenant.hasLicense ? 'Yes' : 'No'}</td>
                <td>{tenant.tokensRemaining}</td>
                <td>{tenant.tokensTotal}</td>
                <td>{percentage.toFixed(2)}%</td>
                <td>{expirationDate}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default AnalyzeTokenUsage
